import { ISendingMessage } from '@interfaces/ISendingMessage';
import { IMailingState, initialMailingsState } from './mailings.state';
import { EMailingsActions, MailingsActions } from './mailings.actions';

export const mailingsReducers = (
  state = initialMailingsState,
  action: MailingsActions
): IMailingState => {
  switch (action.type) {
    case EMailingsActions.CreateMailing:
      return { ...state, loading: { ...state.loading, create: true } };
    case EMailingsActions.CreateMailingFailure:
      return {
        ...state,
        loading: { ...state.loading, create: false },
        errors: { ...state.errors, create: action.errors },
      };
    case EMailingsActions.CreateMailingSuccess:
      return {
        ...state,
        mailings: [...state.mailings, action.mailing],
        loading: { ...state.loading, create: false },
        errors: { ...state.errors, create: {} },
      };

    case EMailingsActions.GetMailings:
      return { ...state, loading: { ...state.loading, getAll: true } };
    case EMailingsActions.GetMailingsFailure:
      return { ...state, loading: { ...state.loading, getAll: false } };
    case EMailingsActions.GetMailingsSuccess:
      return {
        ...state,
        mailings: action.mailings,
        loading: { ...state.loading, getAll: false },
      };

    case EMailingsActions.UpdateMailing:
      return { ...state, loading: { ...state.loading, edit: true } };
    case EMailingsActions.UpdateMailingFailure:
      return {
        ...state,
        loading: { ...state.loading, edit: false },
        errors: { ...state.errors, edit: action.errors },
      };
    case EMailingsActions.UpdateMailingSuccess:
      return {
        ...state,
        mailings: setMailings(state.mailings, action.mailing_id, action.data),
        loading: { ...state.loading, edit: false },
        errors: { ...state.errors, edit: {} },
      };

    case EMailingsActions.GetMailing:
      return { ...state, loading: { ...state.loading, get: true } };
    case EMailingsActions.GetMailingFailure:
      return { ...state, loading: { ...state.loading, get: false } };
    case EMailingsActions.GetMailingSuccess:
      return {
        ...state,
        loading: { ...state.loading, get: false },
        selectMailing: action.mailing,
      };

    case EMailingsActions.GetResults:
      return { ...state, loading: { ...state.loading, results: true } };
    case EMailingsActions.GetResultsFailure:
      return { ...state, loading: { ...state.loading, results: false } };
    case EMailingsActions.GetResultsSuccess:
      return {
        ...state,
        loading: { ...state.loading, results: false },
        results: action.results,
      };

    default:
      return { ...state };
  }
};

const setMailings = (
  mailings: ISendingMessage[],
  id: number,
  data: ISendingMessage
): ISendingMessage[] => {
  const mailingsCopy = [...mailings];
  const index = mailingsCopy.findIndex(m => m.id === id);
  mailingsCopy.splice(index, 1, data);

  return mailingsCopy;
};
